import { Button } from '@components/primitives/Button';
import { Box, Typography } from '@mui/material';

interface EmptyStateProps {
  onViewAllNotes: () => void;
}

/**
 * Pure UI component for empty state when no notes need review
 * Provides a CTA to view all notes
 */
export const EmptyState: React.FC<EmptyStateProps> = ({ onViewAllNotes }) => {
  return (
    <Box
      sx={{
        p: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        minHeight: 300,
      }}
    >
      <Typography
        variant="h6"
        sx={{ mb: 2, color: 'text.secondary', fontWeight: 400 }}
      >
        Nothing to review
      </Typography>
      
      <Typography 
        variant="body2" 
        sx={{ mb: 3, color: 'text.secondary', maxWidth: 300 }}
      >
        All caught up! You&apos;ve reviewed all your notes.
      </Typography>

      <Button
        variant="outlined"
        color="primary"
        onClick={onViewAllNotes}
        sx={{ minWidth: 150 }}
      >
        View All Notes
      </Button>
    </Box>
  );
};